import {z} from 'zod'

export const materialVariationSchema = z.object({
  value: z.string(),
  description: z.string()
})

export const materialVariationsSchema = z.object({
  slump: materialVariationSchema.nullable(),
  setControl: materialVariationSchema.nullable()
})

export const materialSchema = z.object({
  materialId: z.string().nullable(),
  materialNumber: z.string().nullable(),
  materialDescription: z.string().nullable(),
  customerMaterialDescription: z.string().optional().nullable()
})

export const contractSchema = z.object({
  contractNumber: z.string().optional(),
  contractItemPositionNumber: z.string().optional(),
  // Additional contract fields for future use (salesOffice, marketArea, etc.)
  orgUnitId: z.string().optional(),
  customerNumber: z.string().optional(),
  salesOffice: z.string().optional(),
  contractDescription: z.string().optional(),
  zkPartner: z.string().optional()
})

export const mixFormSchema = z.object({
  contract: contractSchema.optional(),
  material: materialSchema.optional(),
  materialVariations: materialVariationsSchema.optional()
})
